import { InputAdornment } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';

export const chatInboxStyles = {
    width: "100%",
    maxWidth: {
      xs: "100%",     
      sm: 300,       
      md: 340,   
      lg: 412,      
      xl: 460,       
      xxl: 480,
    },        
    height: "100%",
    bgcolor: "#fff",
    border: "1px solid #cdccf0",
    borderRadius: "16px 16px 16px 16px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    p: "0px 1px 14px",
    fontFamily: "Poppins, -apple-system, Roboto, Helvetica, sans-serif",
    fontWeight: 400,
    boxShadow: "14px 28px 45px #7090b033",
  }



  export const searchTextFieldSx = {
    color: "#6e6d6a",
    bgcolor: "#f2f2f8",
    borderRadius: "50px",
    p: "0px", // Reduce padding
    fontSize: "14px",
    border: "none",
    outline: "none",
    marginTop: 1,
    mb: 1,
  };
  
  export const searchInputProps = {
    startAdornment: (
      <InputAdornment position="start">
        <SearchIcon sx={{ color: "#6e6d6a", fontSize: 20 }} />
      </InputAdornment>
    ),
    sx: {
      height: "45px", // control the overall height
      "& .MuiOutlinedInput-input": {
        padding: "8px 0px", // reduce vertical padding of the input text
        fontSize: "14px",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
    },
  };



  export const recentMessagesHeadingSx = {
    mb: 1,
    color: "#2e2e2e",
    backgroundColor: "#fffcf2",
    p: 1,
    width: "100%",
    textAlign: "center",
  };
  
  export const messagesListSx = {
    width: "100%",
    maxWidth: 405,
    // height: "60vh",
    bgcolor: "background.paper",
    p: 0,
    overflowY: "auto",
    scrollbarWidth: "thin",
    scrollbarColor: "#5e5acf transparent",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5e5acf",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
  };


  